import { render, staticRenderFns } from "./WineDetails.vue?vue&type=template&id=7e93b7aa"
import script from "./WineDetails.vue?vue&type=script&lang=ts"
export * from "./WineDetails.vue?vue&type=script&lang=ts"
import style0 from "./WineDetails.vue?vue&type=style&index=0&id=7e93b7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports